module.exports = __webpack_public_path__ + "static/media/quote3.2a9a0b1f.png";